module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('to-do'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "info"
  }, [_c('p', [_vm._v("Double-click to edit a todo")]), _vm._v(" "), _c('p', [_vm._v("Written by Andrea B.A.")]), _vm._v(" "), _c('p', [_vm._v("Not part of "), _c('a', {
    attrs: {
      "href": "http://todomvc.com"
    }
  }, [_vm._v("TodoMVC")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d1c351b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 34
// module chunks = 1